import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { authRouting } from './auth.routing';

import { MapsModule } from '../maps/maps.module';
import { SharedModule } from '../shared/shared.module';
import { NewRouteModule } from '../new-route/new-route.module';
import { RouteOverviewModule } from '../route-overview/route-overview.module';
import { RouteDetailModule } from '../route-detail/route-detail.module';
import { ProjectOverviewModule } from '../project-overview/project-overview.module';
import { DashboardOverviewModule } from '../dashboard-overview/dashboard-overview.module';

import { AuthComponent } from './auth.component';
import { AuthService } from './services/auth.service';
import { RoleGuardService } from './services/role.guard';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MaterialModule,
    MapsModule,
    SharedModule,
    NewRouteModule,
    RouteOverviewModule,
    RouteDetailModule,
    ProjectOverviewModule,
    DashboardOverviewModule,
    authRouting
  ],
  providers: [
    AuthService,
    RoleGuardService
  ],
  declarations: [
    AuthComponent
  ]
})
export class AuthModule { }



// WEBPACK FOOTER //
// ./src/app/modules/auth/auth.module.ts